/* eslint-disable camelcase */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import { Form, minLengthValidator } from 'cvlib';

const PasswordForm = props => {
  const {
    sso_inicia_sesion_text,
    password,
    login_password_option_button_next,
    login_password_option_button_cancel,
    password_tooltip_completeField_label_validation,
  } = props.translations;
  const { landing_espn_logo_claro_tv_ic } = props.assets;
  const {
    onNextClicked,
    onCancelClicked,
    onClearError,
    error,
    isLoading,
  } = props;

  const [passwordValue, setPasswordValue] = useState('');
  const satisfyPassword = R.allPass([minLengthValidator(1)]);
  const elements = [
    {
      element: 'logo',
      content: landing_espn_logo_claro_tv_ic,
      position: 'center',
      expand: 0.01,
    },
    {
      element: 'title',
      content: sso_inicia_sesion_text,
      expand: 0.01,
    },
    {
      element: 'subtitle',
      content: password,
      expand: 0.3,
    },
    {
      element: 'item',
      type: 'password',
      name: 'password',
      id: 'password',
      expand: 0.3,
      defaultVisible: false,
      error: error.show && error.msg,
      rules: [],
      registerOptions: {
        required: password_tooltip_completeField_label_validation,
      },
      onChange: ({ target }) => {
        setPasswordValue(target.value);
        onClearError();
      },
    },
    {
      element: 'button',
      type: 'red',
      content: login_password_option_button_next,
      submit: onNextClicked,
      expand: 3,
      disabled: isLoading,
      dimmed: !satisfyPassword(passwordValue),
    },
    {
      element: 'button',
      type: 'gray',
      content: login_password_option_button_cancel,
      onClick: onCancelClicked,
      expand: 2,
      position: 'top',
      disabled: isLoading,
    },
  ];

  return <Form elements={elements} />;
};

PasswordForm.propTypes = {
  isLoading: PropTypes.bool,
  onNextClicked: PropTypes.func,
  onCancelClicked: PropTypes.func,
  assets: PropTypes.shape({
    landing_espn_logo_claro_tv_ic: PropTypes.string,
  }),
  onClearError: PropTypes.func,
  error: PropTypes.shape({
    show: PropTypes.bool,
    msg: PropTypes.string,
  }),
  translations: PropTypes.shape({
    sso_inicia_sesion_text: PropTypes.string,
    password: PropTypes.string,
    login_password_option_button_cancel: PropTypes.string,
    login_password_option_button_next: PropTypes.string,
    password_tooltip_title_label: PropTypes.string,
    password_tooltip_completeField_label_validation: PropTypes.string,
  }),
};

export default PasswordForm;
